import * as React from "react";
import { Moon, Sun, Monitor } from "lucide-react";
import { Toggle } from "@/components/ui/toggle";
import { useTheme } from "@/contexts/theme-context";

export function ThemeToggle() {
  const { theme, setTheme, actualTheme } = useTheme();

  const handleToggle = () => {
    // Cycle through: light -> dark -> system -> light
    if (theme === "light") {
      setTheme("dark");
    } else if (theme === "dark") {
      setTheme("system");
    } else {
      setTheme("light");
    }
  };

  const getIcon = () => {
    if (theme === "system") {
      return <Monitor className="h-4 w-4" />;
    }
    return actualTheme === "dark" ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />;
  };

  const getLabel = () => {
    if (theme === "system") {
      return `System (${actualTheme})`;
    }
    return theme === "dark" ? "Dark" : "Light";
  };

  return (
    <Toggle
      variant="outline"
      size="default"
      pressed={actualTheme === "dark"}
      onPressedChange={handleToggle}
      className="transition-all duration-200 hover:scale-105"
      aria-label={`Switch to ${theme === "light" ? "dark" : theme === "dark" ? "system" : "light"} theme`}
      title={`Current theme: ${getLabel()}. Click to cycle themes.`}
    >
      <div className="transition-transform duration-200 hover:rotate-12">
        {getIcon()}
      </div>
      <span className="sr-only">Toggle theme</span>
    </Toggle>
  );
}

export function ThemeToggleWithLabel() {
  const { theme, setTheme, actualTheme } = useTheme();

  const handleToggle = () => {
    // Cycle through: light -> dark -> system -> light
    if (theme === "light") {
      setTheme("dark");
    } else if (theme === "dark") {
      setTheme("system");
    } else {
      setTheme("light");
    }
  };

  const getIcon = () => {
    if (theme === "system") {
      return <Monitor className="h-4 w-4" />;
    }
    return actualTheme === "dark" ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />;
  };

  const getLabel = () => {
    if (theme === "system") {
      return `System (${actualTheme})`;
    }
    return theme === "dark" ? "Dark" : "Light";
  };

  return (
    <Toggle
      variant="outline"
      pressed={actualTheme === "dark"}
      onPressedChange={handleToggle}
      className="transition-all duration-200 hover:scale-105 gap-2 px-3"
      aria-label={`Switch to ${theme === "light" ? "dark" : theme === "dark" ? "system" : "light"} theme`}
      title={`Current theme: ${getLabel()}. Click to cycle themes.`}
    >
      <div className="transition-transform duration-200 hover:rotate-12">
        {getIcon()}
      </div>
      <span className="text-sm">{getLabel()}</span>
    </Toggle>
  );
}